import React from 'react'

function IconApp({ color = 'currentColor', ...props }) {
  return (
    <svg
      width="22"
      height="21"
      viewBox="0 0 22 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.6951 11.7956C16.9734 12.2726 17.5858 12.4337 18.0628 12.1554C18.5398 11.8771 18.7009 11.2647 18.4226 10.7877L16.6951 11.7956ZM11.554 1L12.4177 0.496043C12.2366 0.185612 11.9028 -0.00374281 11.5434 5.58496e-05C11.184 0.00385451 10.8543 0.200222 10.6798 0.514412L11.554 1ZM1 20L0.125812 19.5144C-0.0758559 19.8775 -0.032133 20.3274 0.235665 20.6448C0.503462 20.9623 0.939589 21.0811 1.33142 20.9435L1 20ZM11.4102 16.3431L11.7665 15.4088C11.5456 15.3245 11.3019 15.3213 11.0788 15.3997L11.4102 16.3431ZM20.6437 20.9344C21.1597 21.1312 21.7376 20.8723 21.9344 20.3563C22.1312 19.8403 21.8723 19.2624 21.3563 19.0656L20.6437 20.9344ZM18.4226 10.7877L12.4177 0.496043L10.6903 1.50396L16.6951 11.7956L18.4226 10.7877ZM10.6798 0.514412L0.125812 19.5144L1.87419 20.4856L12.4282 1.48559L10.6798 0.514412ZM1.33142 20.9435L11.7416 17.2866L11.0788 15.3997L0.668577 19.0565L1.33142 20.9435ZM11.0539 17.2775L20.6437 20.9344L21.3563 19.0656L11.7665 15.4088L11.0539 17.2775Z"
        fill={color}
      />
    </svg>
  )
}

export default IconApp
